import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import background from "./assets/background.svg";

let theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Poppins",
      color: "white",
    },
    h3: {
      fontFamily: "Bangers",
      letterSpacing: "0.2em",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: "smooth",
        },
        body: {
          background: `#02052C url(${background}) no-repeat center`,
          backgroundSize: "cover",
        },
        img: {
          maxWidth: "100%",
          height: "auto",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "0.4em",
        },
      },
      variants: [
        {
          props: { variant: "outlined" },
          style: {
            borderColor: "white",
            color: "white",
          },
        },
        {
          props: { variant: "gradient" },
          style: {
            background:
              "radial-gradient(267.56% 2139.85% at 3.42% 30.43%, #AD00FF 0%, #26D2D1 100%)",

            "&:disabled": {
              background: "rgba(255, 255, 255, 0.1)",
              color: "black",
            },
          },
        },
      ],
    },
    MuiLink: {
      defaultProps: {
        underline: "none",
        color: "white",
      },
    },
  },
});

theme = responsiveFontSizes(theme);

theme.typography.h2 = {
  fontFamily: theme.typography.h3.fontFamily,
  fontSize: "2.6rem",
  letterSpacing: "0.2em",
  "@media (min-width:600px)": {
    fontSize: "5em",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "8rem",
  },
};

export default theme;
